import { Pipe, PipeTransform } from '@angular/core';
// Importación de Angular Fire 2
import { AngularFirestore } from 'angularfire2/firestore';
@Pipe({
  name: 'obtenerPropiedadDeServicio'
})
export class ObtenerPropiedadDeServicio implements PipeTransform {
    constructor(public afs: AngularFirestore) { }
  transform(id: any, propiedad:any): any {
      if(id)
        return this.afs.collection('servicios').doc(id).valueChanges().take(1).map(servicio => servicio[propiedad]);
  }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/obtener-propiedad-servicio.pipe.ts